import { OfficeRouteItemType } from './OfficeRouteItemType';
export function isMosRouteItem(routeItem) {
    return routeItem.type === OfficeRouteItemType.Mos;
}
export function isDraftContentRouteItem(initialRouteItem) {
    var routeItem = initialRouteItem;
    return (routeItem.route === 'MyContent' &&
        routeItem.entityId === 'drafts' &&
        routeItem.subEntityId === 'content');
}
export function isExtendedRouteItem(initialRouteItem) {
    var routeItem = initialRouteItem;
    return routeItem.entityId !== undefined;
}
//# sourceMappingURL=OfficeRouteItem.js.map